import { createAction } from 'redux-act';

/** Полезная нагрузка формы оценки актива (данные с бэка или для создания). */
export type ValuationFormPayload = Record<string, unknown> | null;

export const setValuationModalVisible = createAction<boolean>('SET_VALUATION_MODAL_VISIBLE');
export const setValuationForm = createAction<ValuationFormPayload>('SET_VALUATION_FORM');
